module.exports = __webpack_public_path__ + "media/icons/key-z-bd85fc43.svg";